export default __webpack_public_path__ + "5a47dd3372bc41bd706312d2b7a2b5d4.png";